<section class="services-card">
  <h3 class="services-card__label">
    <ion-icon name="camera-outline"></ion-icon>
    {{ "UX_TEXT.DEMANDE.UPLOAD.TITLE" | translate }}
    <span class="services-card__label-opt">({{ "UX_TEXT.DEMANDE.UPLOAD.MAX_FILES" | translate }})</span>
  </h3>

  <div class="upload-zone" *ngIf="!hasMedia" (click)="onSelectImage()">
    <div class="upload-zone__icon">
      <ion-icon name="camera-outline"></ion-icon>
    </div>
    <p class="upload-zone__title">{{ "UX_TEXT.DEMANDE.UPLOAD.ZONE_TITLE" | translate }}</p>
    <p class="upload-zone__hint">{{ "UX_TEXT.DEMANDE.UPLOAD.ZONE_HINT" | translate }}</p>
    <div class="upload-zone__actions">
      <button
        type="button"
        class="upload-zone__btn upload-zone__btn--primary"
        (click)="openCamera.emit(); $event.stopPropagation()"
      >
        <ion-icon name="camera-outline"></ion-icon>
        {{ "UX_TEXT.DEMANDE.UPLOAD.PHOTO" | translate }}
      </button>
      <button
        type="button"
        class="upload-zone__btn upload-zone__btn--secondary"
        (click)="openGallery.emit(); $event.stopPropagation()"
      >
        <ion-icon name="images-outline"></ion-icon>
        {{ "UX_TEXT.DEMANDE.UPLOAD.GALLERY" | translate }}
      </button>
    </div>
  </div>

  <div class="upload-thumbs" *ngIf="hasMedia">
    <ng-container *ngFor="let item of filesPaths; let index = index">
      <div class="upload-thumb" *ngIf="item.path" [class.upload-thumb--video]="item.type === 'video'">
        <img
          *ngIf="item.type === 'image'"
          [src]="item.path"
          alt="media"
          (click)="displayMedia.emit({ path: item.path, type: item.type })"
        />
        <video
          *ngIf="item.type === 'video'"
          [src]="item.path"
          (click)="displayMedia.emit({ path: item.path, type: item.type })"
        ></video>
        <button type="button" class="upload-thumb__remove" (click)="removeImage.emit(index)">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>
    </ng-container>
    <button
      type="button"
      class="upload-thumb upload-thumb--add"
      [disabled]="!canAddMoreMedia"
      [class.upload-thumb--disabled]="!canAddMoreMedia"
      (click)="onSelectImage()"
    >
      <ion-icon name="add-outline"></ion-icon>
    </button>
  </div>
</section>
